import React from 'react'

export default function ListDropDown(menu_drop) {
  return (
    (menu_drop !== undefined || menu_drop !== null)
        ?
            (

                menu_drop.menu_drop.map((menu) => {
                    const openInNewTab = menu.elements.footer_menu_links__footer_open_in_new_tab?.[0]?.name === "Yes";
                    return(
                        <a
                            key={menu.id}
                            className="dropdown-item"
                            data-menu={`NAV ${menu.elements.footer_menu_links__footer_menu_label_name.value}`}
                            data-target="NAV"
                            href={menu.elements.footer_menu_links__footer_menu_link.value}
                            title={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                            aria-label={menu.elements.footer_menu_links__footer_menu_aria_label.value}
                            target={openInNewTab ? "_blank" : "_self"}
                        >
                            {menu.elements.footer_menu_links__footer_menu_label_name.value}
                        </a>
                    )
                })
            )
        :
        (
            <></>
        )
  )
}
